import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, DialogActions} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import socketIOClient from 'socket.io-client';
import UrlasserDialog from '../../central/components/dialogs/UrlasserDialog';

// const PORT = process.env.NODE_ENV==="production"?443:5000;
// const ENDPOINT = `http://localhost:${PORT}`;

export default function BroadcastOn (props) {
    const datetime = new Date();
    const {open, onClose} = props;
    const [updateInformation, setUpdateInformation] = useState({
        values:{
            author:'',
            timestamp:`${datetime.getFullYear()}-${(datetime.getMonth() + 1).toString().padStart(2,'0')}-${datetime.getDate().toString().padStart(2,'0')}T${datetime.getHours().toString().padStart(2,'0')}:${datetime.getMinutes().toString().padStart(2,'0')}`,
            commit:''
        }
    });
    const [openUrlasserDialog, setOpenUrlasserDialog] = useState(false);
    const [disableConfirm, setDisableConfirm] = useState(true);
    const [socket, setSocket] = useState(null); 
    const handleChange = (event) => {
        event.persist();
        setUpdateInformation({
            values:{
                ...updateInformation.values, 
                [event.target.name]:event.target.value
            }
        });
    };
    const handleOpenUrlasserDialog = () => {
        setOpenUrlasserDialog(true);
    };
    const handleCloseUrlasserDialog = () => {
        setOpenUrlasserDialog(false);
    };
    const handleAfterVerify = () => {
        socket.emit('editBroadcast', updateInformation); 
        setOpenUrlasserDialog(false);
        document.getElementById('action-permitted').innerHTML='Update wurde erfolgreich mitgeteilt';
        setTimeout(() => {
            onClose();
        }, 1000);
    };

    useEffect(() => {
        const so = socketIOClient();
        setSocket(so);
        return () => so.disconnect();
    }, []);

    useEffect(() => {
        const {author, timestamp} = updateInformation.values;
        if (author !== '' && timestamp !== ''){ setDisableConfirm(false); } 
        else { setDisableConfirm(true); }
    }, [updateInformation]);

    return (
        <div>
            <UrlasserDialog 
                onVerifyClick={handleAfterVerify}
                onClose={handleCloseUrlasserDialog}
                open={openUrlasserDialog}
            />
            <Dialog open={open} onClose={onClose}>
                <AppBar position="static" color="primary">
                    <Toolbar>
                        <div><Typography variant="h5">Update mitteilen</Typography></div>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <form>
                        <TextField
                            onChange={handleChange}
                            className="text-field"
                            color="primary"
                            fullWidth
                            label="Veranlasser"
                            name="author"
                            variant="standard"
                        />
                        <TextField
                            style={{marginTop: 20}}
                            onChange={handleChange}
                            className="text-field"
                            color="primary"
                            fullWidth
                            label="Updatezeitpunkt"
                            value={updateInformation.values.timestamp}
                            name="timestamp"
                            type="datetime-local"
                            variant="standard"
                            InputLabelProps={{shrink: true}}
                        />
                        <TextField
                            style={{marginTop: 10}}
                            onChange={handleChange}
                            className="text-field"
                            color="primary"
                            fullWidth
                            label="Kommentar"
                            name="commit"
                            variant="standard"
                        />
                        <p id='action-permitted' style={{color:'green', fontSize:10, fontFamily:'Arial, Helvetica, sans-serif', marginTop:15}}/>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={onClose}>Abbrechen</Button>
                    <Button color="primary" variant="contained" disabled={disableConfirm} onClick={handleOpenUrlasserDialog}>Bestätigen</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
};
